import { Level } from "@src/redux/index";
import LevelDetails from "./LevelDetails";
import { Button, Col, Empty, Row, Switch } from "antd";
import { useTranslation } from "react-i18next";
import React, { useContext, useMemo } from "react";
import { CSS } from "@dnd-kit/utilities";
import { useSortable } from "@dnd-kit/sortable";
import { HolderOutlined } from "@ant-design/icons";

type Props = {
  level: Level[];
  setLevelList: React.Dispatch<React.SetStateAction<Level[]>>;
  
  levelList?: Level[];
};

type LevelComponentProps = {
  level: {
    id: string;
    name: string;
    fieldType: string;
    removableLevelAttributeIdList: any[];
    allowKitAssign?: boolean;
  }[];
  setLevelList: React.Dispatch<
    React.SetStateAction<
      {
        id: string;
        name: string;
        fieldType: string;
        removableLevelAttributeIdList: any[];
        allowKitAssign?: boolean;
      }[]
    >
  >;
};


interface RowContextProps {
  setActivatorNodeRef?: (element: HTMLElement | null) => void;
  listeners?: any;
}
interface SortableRowProps {
  "data-row-key": string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
}
const RowContext = React.createContext<RowContextProps>({});

const SortableRow: React.FC<SortableRowProps> = (props) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: props["data-row-key"] });

  const style: React.CSSProperties = {
    ...props.style,
    transform: CSS.Translate.toString(transform),
    transition,
    ...(isDragging ? { position: "relative" } : {}),
  };

  const contextValue = useMemo<RowContextProps>(
    () => ({ setActivatorNodeRef, listeners }),
    [setActivatorNodeRef, listeners]
  );

  return (
    <RowContext.Provider value={contextValue}>
      <Row
        ref={setNodeRef}
        style={style}
        {...attributes}
        align="middle"
        gutter={16}
      >
        {props.children}
      </Row>
    </RowContext.Provider>
  );
};
const DragHandle: React.FC = () => {
  const { setActivatorNodeRef, listeners } = useContext(RowContext);
  return (
    <Button
      type="text"
      size="small"
      icon={<HolderOutlined />}
      style={{ cursor: "move" }}
      ref={setActivatorNodeRef}
      {...listeners}
    />
  );
};

const LevelComponent = (props: Props) => {
  const { t } = useTranslation();
  const { level, setLevelList } = props;

  return (
    <React.Fragment>
      {level.length !== 0 && (
        // <div
        //   className="level-card-container"
        //   style={{
        //     display: "flex",
        //     flexDirection: "row",
        //     alignItems: "center",
        //     width: "85%",
        //     marginLeft: "54px",
        //     marginBottom: "20px",
        //   }}
        // >
        //   <div className="level-card-icon-container" style={{ width: "100%" }}>
        //     <b className="level-name-s-no">{t("s_no")}</b>
        //     <b className="level-name-label">{t("name")}</b>
        //     <b className="level-attributes-label">{t("attributes")}</b>
        //     <b>{t("assign_operator")}</b>
        //   </div>
        // </div>
        <Row
          gutter={24}
          justify={"space-between"}
          style={{
            marginBottom: "10px",
            width: "85%",
            padding: "10px",
            borderRadius: "10px",
            marginLeft: "30px",
            alignItems: "center",
          }}
          align={"middle"}
        >
          <b></b>
          <b>{t("s_no")}</b>
          <b className="level-label-container">{t("name")}</b>
          <b className="level-attribute-label-container">{t("attributes")}</b>
          <b>{t("allow_operator")}</b>
          <b>{t("")}</b>
        </Row>
      )}
          {level?.map((list: Level, index: number) => {
        const isFirstLevel = index === 0;
        return (
          <SortableRow key={list.id} data-row-key={list.id || ""}>
            <Row
              gutter={24}
              justify={"space-between"}
              style={{
                marginBottom: "10px",
                width: "83%",
                padding: "10px",
                backgroundColor: "white",
                borderRadius: "10px",
                marginLeft: "30px",
                alignItems: "center",
              }}
              align={"middle"}
            >
              <DragHandle />
              <b>{index + 1}</b>
              <LevelDetails
                level={list}
                levelList={level}
                setLevelList={setLevelList}
                levelIndex={index}
              />
            
           
            </Row>
          </SortableRow>
        );
      })}

      <Row justify={"center"} align={"middle"} style={{ width: "100%" }}>
        {level?.length === 0 && (
          <Col span={24}>
            <Empty description={t("atleast_one_level_is_mandatory")} />
          </Col>
        )}
      </Row>
    </React.Fragment>
  );
};

export default LevelComponent;
